class Helpers{
    
    notEmptyComponent = (data, comp) => {
        let c = (data !== undefined && data !== '' && data && (data.length > 0) ? comp : <></>);
        return c;
    }

    isEmpty(val){
        return (val === undefined || val === null || val === 0 || val === '');
    }

    defaultVal = (val, def = '') => {
        console.log(typeof(val),val);
        switch(typeof(val)){
            
            default:
                val = (val === undefined || val === null || val === false) ? def : val;
            break;
        }
        return val;
    }
    
    getStatus = (n) => {
        n = n === undefined ? -1 : parseInt(n);
            let text;
            switch(n){
                case 0:
                    text = "In Verification"
                break;
                case 1:
                    text = "Got Devices"
                    
                break;
                case 2:
                    text = "CheckedIn"
                    
                break;
                case 3:
                    text =  "Returned Devices" 
                break;
                case 4:
                    text = "Checked Out"
                    
                break;
                case -1:
                    text = 
                    "Not Arrived Yet"
                break;
                case -2:
                    text =
                        "Cancelled Booking"
                    
                break;
                default:
                    text =  "Not Allowed"
                    
                break;
            }
            return text;
    }
    formatExport = (data, labels = {}, all = false) => {
        let head = Array.isArray(data) && data.length > 0 ? Object.keys(data[0]) : [];
        let header = [];
        if(Array.isArray(head)){
            head.forEach((x)=>{
                let lbl = labels[x] !== undefined && labels[x] !== null ? labels[x] : false;
                if(all){
                    header.push({ label: lbl ? lbl : x, key: x });
                }else if(lbl){
                    header.push({ label: lbl ? lbl : x, key: x });
                }
            });
        }
        
        data = Array.isArray(data) && data.length > 0 ? data.map((x)=>{
            let fd = {};
            header.forEach((v)=>{
                if(v['key'] === 'status'){
                    fd[v['key']] = this.getStatus(x[v['key']]);
                }else if(typeof(x[v['key']]) === 'object'){
                    fd[v['key']] = x[v['key']]['exec']!== undefined ? eval(x[v['key']]['exec']) : x[v['key']]['val'];
                }else{
                    fd[v['key']] = x[v['key']];
                }
                
            });
           // console.log(fd);
            return fd;
        }) : [];
        //console.log({header: header, data: data});
        return {header: header, data: data};
    }

    defaultImg = (dataOrUrl, def = '')=>{
        let jsx;
        
        
        let val;
        try {
            def = this.isEmpty(def) ? this.broken('load') : def;
            val = JSON.parse(dataOrUrl);
        } catch (err) {
            console.log(err);
            val = (dataOrUrl) ? def : dataOrUrl;
        }
        console.log(typeof(val),val);
        switch(typeof(val)){
            case 'string':
                def = this.isEmpty(def) ? this.broken('load') : def;
                val = this.isURL(val) ? val : this.broken('link');
                jsx = (<div><img src={val} className="max100" alt="" /></div>);
            break;
            default:
                def = this.isEmpty(def) ? this.broken('load') : def;
                jsx = (<div className="row"><div className="col-6 align-self-center"><img src={val.url} className="max100" alt={val.insertedId} /></div><div className="col-6 align-self-center"><a href={val.url} target="_blank" rel="noreferrer">View Full Image</a></div></div>);
            break;
        }
        
        return jsx;
    }

    broken = (data = 'link') => {
        switch(data){
            case 'img':
                data = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8Zz4KICA8cGF0aCBkPSJtMTgzLjIxIDUwNC41M3YtMjU3LjA2aDMyMS4zMnYtMzIuMTU2aC0zNTMuNDh2MzIxLjM3aDEyOC41M3YtMzIuMTU2eiIvPgogIDxwYXRoIGQ9Im01NjguOCA1MDQuNTNoLTIyNC45NXYzMi4xNTZoMjU3LjExdi0yODkuMjFoLTMyLjE1NnoiLz4KICA8cGF0aCBkPSJtMzExLjc0IDMxMS43NGMwIDE3Ljc1OC0xNC4zOTggMzIuMTU2LTMyLjE1NiAzMi4xNTYtMTcuNzYyIDAtMzIuMTU2LTE0LjM5OC0zMi4xNTYtMzIuMTU2IDAtMTcuNzYyIDE0LjM5NS0zMi4xNTYgMzIuMTU2LTMyLjE1NiAxNy43NTggMCAzMi4xNTYgMTQuMzk1IDMyLjE1NiAzMi4xNTYiLz4KICA8cGF0aCBkPSJtMjc5LjU4IDQwOC4xNi02NC4yNjYgNjQuMjY2aDk2LjQyMnYtMzIuMTU2eiIvPgogIDxwYXRoIGQ9Im00NDAuMjcgNDA4LjE2aC0zMi4xMDl2MzIuMTA5aC0zMi4xNTZ2MzIuMTU2aDE2MC42OWwtNzcuMTQ1LTk2LjQyMmgtMTkuMjc3eiIvPgogIDxwYXRoIGQ9Im0zMjMuMSA0MjguOSAxMS4zNjcgMTEuMzYzaDkuMzc1di0zMi4xMDloMzIuMTU2di0zMi4xNTZoMzIuMTU2di0zMi4xNTZoMjUuNjY4bC0yNS42NjgtMzIuMTA1eiIvPgogPC9nPgo8L3N2Zz4K";
            break;
            case 'load':
                data = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNzUycHQiIGhlaWdodD0iNzUycHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDc1MiA3NTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8Zz4KICA8cGF0aCBkPSJtMzE2LjIyIDUwMC40N2MtNy4yNzczIDQuMjkzLTE1LjYxMyA2LjUzNTItMjQuMDU5IDYuNTM1MmgtMC4wMTU2MjVjLTAuNzczNDQgMC0xLjUtMC4xODc1LTIuMjU3OC0wLjIyMjY2bC01My40MDIgNTMuNDAyYy0xMi4zMjggMTIuMjk3LTMyLjM0NCAxMi4yOTctNDQuNjYgMC0xMi4yOTctMTIuMjk3LTEyLjMxMi0zMi4zNDQgMC00NC42NDVsNTMuMzg3LTUzLjQwMmMtMC40MjU3OC04Ljk5NjEgMS41NDY5LTE4LjE1MiA2LjM0NzctMjYuMzYzIDIuMTY0MS0zLjY5NTMgNC41MTU2LTYuODIwMyA3LjE4MzYtOS41MDM5bDE4LjA1OS0xOC4wOWMtMTQuNjk1IDAuOTI5NjktMjkuMTA5IDYuODIwMy00MC4zNDggMTguMDQzbC02Ni45NjUgNjYuOTk2Yy0yNC42NTYgMjQuNjI1LTI0LjY1NiA2NC42MjkgMCA4OS4yODUgMjQuNjcyIDI0LjY3MiA2NC42NDUgMjQuNjcyIDg5LjI4NSAwbDY2Ljk4LTY2Ljk2NWMxMS4yNTQtMTEuMjU0IDE3LjExMy0yNS42ODQgMTguMDQzLTQwLjM2M2wtMTguMDQzIDE4LjA0M2MtMi42MDU1IDIuNjI1LTUuNzMwNSA1LjAyNzMtOS41MzUyIDcuMjV6Ii8+CiAgPHBhdGggZD0ibTI2NS4xNyA0NDMuNzdjLTcuMTIxMSAxMi4xMDktNS41ODk4IDI3Ljg3OSA0LjgwMDggMzguMjY2IDEwLjM4NyAxMC40MTggMjYuMTU2IDExLjkzNCAzOC4yNjYgNC44MTY0IDIuMjczNC0xLjMyNDIgNC40NTMxLTIuODM5OCA2LjM3ODktNC43ODEybDI3LjMwOS0yNy4zMDkgMTcuMzQ4LTE3LjM2My0yMi4zMi0yMi4zMiAyMi4zMDUtMjIuMzItMjIuMzItMjIuMzItMjIuMzA1IDIyLjMyLTE3LjM2MyAxNy4zNjMtMjcuMzA5IDI3LjI5M2MtMS45MzM2IDEuOTIxOS0zLjQ2NDggNC4wOTc3LTQuNzg5MSA2LjM1NTV6Ii8+CiAgPHBhdGggZD0ibTU4Mi41IDE2OS40OWMtMjQuNjU2LTI0LjY3Mi02NC42MjktMjQuNjcyLTg5LjI4NSAwbC02Ni45OCA2Ni45NjVjLTExLjIyMyAxMS4yNTQtMTcuMDk4IDI1LjY1Mi0xOC4wMTIgNDAuMzYzbDE4LjAyNy0xOC4wMTJjMi42ODM2LTIuNzE0OCA1LjgwODYtNS4wODIgOS41ODItNy4yNzczIDcuMjc3My00LjI3NzMgMTUuNTk4LTYuNTM1MiAyNC4wNTktNi41MzUyIDAuNzczNDQgMCAxLjUgMC4xODc1IDIuMjczNCAwLjIyMjY2bDUzLjM4Ny01My40MDJjMTIuMzEyLTEyLjI5NyAzMi4zNDQtMTIuMjk3IDQ0LjY2IDAgMTIuMjk3IDEyLjI5NyAxMi4zMTIgMzIuMzQ0LTAuMDE1NjI2IDQ0LjY0NWwtNTMuMzcxIDUzLjQwMmMwLjQyNTc4IDguOTk2MS0xLjU0NjkgMTguMTg0LTYuMzc4OSAyNi4zOTUtMi4xNDg0IDMuNjY0MS00LjUxNTYgNi44MjAzLTcuMjE0OCA5LjUzNTJsLTE4LjAyNyAxOC4wMTJjMTQuNjk1LTAuODk4NDQgMjkuMTA5LTYuNzU3OCA0MC4zNjMtMTguMDEybDY2Ljk0OS02Ni45OTZjMjQuNjU2LTI0LjY3NiAyNC42NTYtNjQuNjQ4LTAuMDE1NjI1LTg5LjMwNXoiLz4KICA8cGF0aCBkPSJtNDgyLjA1IDI2OS45NmMtMTAuMzg3LTEwLjM4Ny0yNi4xNTYtMTEuOTM0LTM4LjI2Ni00LjgxNjQtMi4yNzM0IDEuMzI0Mi00LjQzNzUgMi44NzUtNi4zNzg5IDQuODE2NGwtMjcuMjkzIDI3LjI3Ny0xNy4zNjMgMTcuMzMyIDIyLjMzNiAyMi4zNTItMjIuMzIgMjIuMzIgMjIuMzIgMjIuMzIgNjYuOTc3LTY2Ljk3N2MxLjk0MTQtMS45NDE0IDMuNDcyNy00LjEzNjcgNC43ODEyLTYuMzc4OSA3LjEyNS0xMi4wODYgNS41OTM4LTI3Ljg3MS00Ljc5My0zOC4yNDZ6Ii8+CiAgPHBhdGggZD0ibTIzNi40MSAyNDcuNTkgMTEuMTY0LTExLjE2NCA4OS4zMDkgODkuMzA5LTExLjE2NCAxMS4xNjR6Ii8+CiAgPHBhdGggZD0ibTIwMi4zNiAzNjAuMmg5NC43MTV2MTUuODAxaC05NC43MTV6Ii8+CiAgPHBhdGggZD0ibTM2MC4yMSAyMDIuMzZoMTUuNzd2OTQuNzE1aC0xNS43N3oiLz4KICA8cGF0aCBkPSJtNDE1LjAyIDQyNi4xOSAxMS4xNjQtMTEuMTY0IDg5LjI5NyA4OS4yOTctMTEuMTY0IDExLjE2NHoiLz4KICA8cGF0aCBkPSJtNDU0LjkzIDM3Nmg5NC43MTV2MTUuNzg1aC05NC43MTV6Ii8+CiAgPHBhdGggZD0ibTM3NiA0NTQuOTNoMTUuNzg1djk0LjcxNWgtMTUuNzg1eiIvPgogPC9nPgo8L3N2Zz4K";
            break;
            default:
                data = 'data:image/svg+xml;base64,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';
            break;
        }
        
        return data;
    }

    isURL(string) {
        var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g);
        return (res !== null)
    };

    isEmail(value) {
        var input = document.createElement('input');
      
        input.type = 'email';
        input.required = true;
        input.value = value;
      
        return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(value);
    }

    
  
    getGender = (g) => {
      g = g.toLowerCase();
      const genders = {
        m:'Male', f: 'Female', o: 'Other'
      }
      return genders[g];
    }

    showPicker = (e) => {
        e.preventDefault();
        const el = e.target;
        if (el.getAttribute("type")==="date" || el.getAttribute("type")==="time" || el.getAttribute("type")==="datetime-local") {
            el.showPicker();
        }
    }

    formControl = (id, label, type, obj = {}, options = [], classname = 'form-control') => {
        let ctrl;
        switch(type){
            case 'select':
                ctrl = () => {
                    return <div className='form-group'>
                        c
                        <select name={id} id={id} className={classname} {...obj} >
                            {options.map((x,i)=>{
                                return <option key={i} index={i} value={x.value}>{x.text}</option>
                            })}
                        </select>
                    </div>
                }
            break;
            case 'button':
                ctrl = () => {
                    return <button {...obj}>{label}</button>
                } 
            break;
            default:
                type = type === 'datetime' ? 'datetime-local' : type;
                ctrl = () => {
                   return  <div className='form-group'>
                        <label htmlFor={id}>{label}</label>
                        <input type={type} name={id} id={id} className={classname} {...obj} />
                    </div>
                }
            break;
        }
        return ctrl();
    }
  
    getAge = (date) => {
      date = date === undefined || date === '' ? new Date() : date;
      date = typeof(date) === 'string' ? new Date(date) :  date;
      console.log(date);
      return Math.floor((new Date() - date.getTime()) / 3.15576e+10);
    }
  
    getDate = (format = 'Y-M-D', date = false, add = {}) => {
      date = date ? date : new Date();
      let y = date.getFullYear() + (add.year !== undefined && !isNaN(add.year) ? add.year : 0); 
      let m = (parseInt(date.getMonth()) + 1) + (add.month !== undefined && !isNaN(add.month) ? add.month : 0);
      
      let d = (parseInt(date.getDate())) + (add.day !== undefined && !isNaN(add.day) ? add.day : 0);
      let hh = parseInt(date.getHours()) + (add.hour !== undefined && !isNaN(add.hour) ? add.hour : 0);
  
      let mm = parseInt(date.getMinutes()) + (add.minute !== undefined && !isNaN(add.minute) ? add.minute : 0);
      hh = mm >= 60 ? hh + Math.floor(mm/60): hh;
      mm = mm >= 60 ? mm - 60: mm;
      let ss = parseInt(date.getSeconds()) + (add.second !== undefined && !isNaN(add.second) ? add.second : 0);
      date = {
        Y: y,
        y: y.toString().slice(2,4),
        m: m,
        M: m < 10 ? '0' + m : m,
        d: date.getDate(),
        D: d < 10 ? '0' + d : d,
        H: hh,
        h: hh < 10 ? '0' + hh : hh,
        i: mm < 10 ? '0' + mm : mm,
        I: mm,
        s: ss < 10 ? '0' + ss: ss,
        S: ss,
        a: hh >= 12 ? (hh - 12) === 0 ? 12 : (hh - 12) : hh,
        A: hh > 12 ? 'PM' : 'AM'
      };
      Object.entries(date).forEach(([k,v])=>{
          format = format.replace(k, v)
         // console.log(k);
        //  console.log(v);
      });
      return format;
  }
  
    datePicker = (date = '', days, format = 'YMD', sep = '-') => {
      days = days * (24 * 60) * 60 * 1000;
      date = date === undefined || date === '' ? new Date() : date;
      date = typeof(date) === 'string' ? new Date(date) :  date;
      
      let time = date.getTime();
      time += days;
      date = new Date(time);
      
      switch(format){
        case 'YMD':
          date = [date.getFullYear(), date.getMonth(), date.getDate()];
          date[1] = date[1] < 10 ? '0' + date[1] : date[1];
          date[2] = date[2] < 10 ? '0' + date[2] : date[2];
          date = date.join(sep);
        break;
        case 'ymd':
          date = [date.getFullYear(), date.getMonth(), date.getDate()];
          date = date.join(sep);
        break;
        default:
          date = [date.getFullYear(), date.getMonth(), date.getDate()];
        break;
      }
      return date;
    }

}

export default Helpers;